import { routes } from "./routes";

export const getRoutesFor = (features: string[]) => {
  const filteredRoutes = routes.filter((route) =>
    route.requiredFeatures.some((required) => features.includes(required))
  );
  return filteredRoutes;
};
